import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BulkUploadProvider } from './contexts/BulkUploadContext';
import { HomePage } from './pages/HomePage';
import { BorrowedBooksPage } from './pages/BorrowedBooksPage';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { AssigneesPage } from './pages/AssigneesPage';
import { BooksPage } from './pages/BooksPage';
import { BulkUploadPage } from './pages/BulkUploadPage';
import { ShelvesPage } from './pages/ShelvesPage';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import './styles/global.css';

function App() {
  return (
    <BulkUploadProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/borrowed" element={<BorrowedBooksPage />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/assignees"
            element={
              <ProtectedRoute>
                <AssigneesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/books"
            element={
              <ProtectedRoute>
                <BooksPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/bulk-upload"
            element={
              <ProtectedRoute>
                <BulkUploadPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/shelves"
            element={
              <ProtectedRoute>
                <ShelvesPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </BulkUploadProvider>
  );
}

export default App;
